import { render, staticRenderFns } from "./goodsfestival.vue?vue&type=template&id=10215b62&scoped=true"
import script from "./goodsfestival.vue?vue&type=script&lang=js"
export * from "./goodsfestival.vue?vue&type=script&lang=js"
import style0 from "./goodsfestival.vue?vue&type=style&index=0&id=10215b62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10215b62",
  null
  
)

export default component.exports